import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GiftCardPurchaseComponent } from './gift-card-purchase.component';

const routes: Routes = [{ path: '', component: GiftCardPurchaseComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class GiftCardPurchaseRoutingModule {}
